import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { IShortLine } from '@ruby/modules/short-line-profile/models/short-line-profile.interface';
import {
  fromShortLineCustomerContact,
  ShortLineCustomerContactActions,
  ShortLineCustomerContactsSelectors
} from '@ruby/modules/short-line-profile/store/short-line-customers.index';

@Component({
  selector: 'ng-sl-customers-container',
  template: `
    <ng-sl-customers *ngIf="(store$ | async) as store"
                     [canEdit]="store.canEdit"
                     [canView]="store.canView"
                     [isAdmin]="store.isAdmin"
                     [loading]="store.contacts.loading"
                     [isProfile]="!!store.profile"
                     [data]="store.contacts.contacts">
    </ng-sl-customers>
  `
})
export class SlCustomersContainer {
  store$!: Observable<{
    contacts: fromShortLineCustomerContact.State;
    canEdit: boolean;
    canView: boolean;
    isAdmin: boolean;
    profile?: IShortLine;
  }>;
  profileId!: string;

  constructor(private store: Store<fromShortLineCustomerContact.State>) {
    this.store$ = this.store.select(ShortLineCustomerContactsSelectors.selectContactsWithProfile).pipe(
      tap((st: {
        contacts: fromShortLineCustomerContact.State;
        canEdit: boolean;
        canView: boolean;
        isAdmin: boolean;
        profile?: IShortLine;
      }) => {
        if (st.profile && this.profileId !== st.profile.reportingMark) {
          this.store.dispatch(ShortLineCustomerContactActions.loadCustomerContacts({ data: st.profile.reportingMark }));
          this.profileId = st.profile.reportingMark;
        }
      })
    );
  }
}
